import { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
    const [changeHeader, setChangeHeader] = useState(false);
    const changeHeaderColor = () => {
        if(window.scrollY >= 50) {
            setChangeHeader(true)
        }else {
            setChangeHeader(false)
        }
    }

    window.addEventListener('scroll', changeHeaderColor)

    return (<header className="header" id="header">
    <nav className="nav container">
      <Link to="/" className="nav__logo">Coffee<span>.</span>co </Link>

      <div className="nav__menu" id="nav-menu">
        <ul className="nav__list">
          <li className="nav__item">
            <Link to="/" className="nav__link">Home</Link>
          </li>
          <li className="nav__item">
            <Link to="./product" className="nav__link">Products</Link>
          </li>
          <li className="nav__item">
            <Link to="./place" className="nav__link">Place</Link>
          </li>
          <li className="nav__item">
            <Link to="./blog" className="nav__link">Blog</Link>
          </li>
        </ul>

        <div className="nav__close" id="nav-close">
          <i className="bx bx-x"></i>
        </div>
      </div>

      <div className="nav__toggle" id="nav-toggle">
        <i className="bx bx-grid-alt"></i>
      </div>
    </nav>
  </header>
    );
};

export default Header;